import { Dispatch, SetStateAction, useState } from "react";
import { MenuItem } from './MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import { MenuItems } from "../../../pages/VendManagementContainer";

interface Props {
    currentSelection: MenuItems;
    setCurrentSection: Dispatch<SetStateAction<MenuItems>>;
}

export function SideBarContainer({ currentSelection, setCurrentSection }: Props) {
    const [showNavMenu, setShowNavMenu] = useState(false);

    return (
        <div className={`border-r-2 border-gray-300 h-full ${showNavMenu ? "w-[300px]" : "w-11"} transition-all duration-500`}>
            <div className="flex justify-end px-2 h-8">
                <button
                    className={"right-0 top-4 cursor-pointer "}
                    onClick={() => setShowNavMenu(!showNavMenu)}>
                { showNavMenu 
                ? <MenuOpenIcon className="w-8 h-8 fill-current" sx={{ fontSize: 27}}/>
                : <MenuIcon className="w-8 h-8 fill-current" sx={{ fontSize: 27}}/>
                }
                </button>
            </div>

            <div
                className={`
                    flex flex-col gap-y-2 justify-centers my-3
                    transition-all duration-100 delay-100
                    ${showNavMenu 
                        ? "opacity-100 translate-x-0 visible" 
                        : "opacity-0 -translate-x-4 invisible"
                    }`}>
                <MenuItem
                    onClick={() => setCurrentSection(MenuItems.DASHBOARD)}
                    texto="Dashboard"
                    isSelected={MenuItems.DASHBOARD == currentSelection}
                    icon={<SpaceDashboardRoundedIcon sx={{ width: 30, height: 30 }}/>}/>

                <MenuItem
                    onClick={() => setCurrentSection(MenuItems.EQUIPOS)}
                    texto="Equipos"
                    isSelected={MenuItems.EQUIPOS == currentSelection}
                    icon={<GroupsRoundedIcon sx={{ width: 30, height: 30 }}/>}/>
            </div>
        </div>
    );
}